import { loading, success, failure } from 'utilities/actions'

import type { ConfirmationError, ConfirmationRequest } from './confirmation'

export const TOGGLE_UNENROLMENT = 'ENROLMENT_DRAFT_TOGGLE_UNENROLMENT' as const
export const ADD_ENROLMENT = 'ENROLMENT_DRAFT_ADD_ENROLMENT' as const
export const REMOVE_ENROLMENT = 'ENROLMENT_DRAFT_REMOVE_ENROLMENT' as const
export const CLEAR_DRAFT = 'ENROLMENT_DRAFT_CLEAR_DRAFT' as const
export const DISMISS_CONFIRMATION =
  'ENROLMENT_DRAFT_DISMISS_CONFIRMATION' as const
export const DISMISS_SUBMIT_FAILURE =
  'ENROLMENT_DRAFT_DISMISS_SUBMIT_FAILURE' as const
// Named after the POST operation, so the Confirm button can gate on it.
export const API_ENROLMENT_ENTITLEMENTS_ENROLMENTS_CREATE =
  'API_ENROLMENT_ENTITLEMENTS_ENROLMENTS_CREATE' as const
export const CONFIRM_DRAFT_STARTED =
  loading(API_ENROLMENT_ENTITLEMENTS_ENROLMENTS_CREATE)
export const CONFIRM_DRAFT_SUCCEEDED =
  success(API_ENROLMENT_ENTITLEMENTS_ENROLMENTS_CREATE)
export const CONFIRM_DRAFT_FAILED =
  failure(API_ENROLMENT_ENTITLEMENTS_ENROLMENTS_CREATE)

// organisationId is the participant's account when they were added, so the
// addition can be dropped if they later move to another account.
export type PendingEnrolment = {
  entitlementId: string;
  participantId: string;
  organisationId: string;
}

export type PendingEnrolmentKey = Pick<
  PendingEnrolment,
  'entitlementId' | 'participantId'
>

const currentScope = (): string =>
  localStorage.getItem('organisation_ids') || ''

export const toggleUnenrolment = (enrolmentId: string) => ({
  type: TOGGLE_UNENROLMENT,
  enrolmentId,
  scope: currentScope(),
})

export const addEnrolment = (enrolment: PendingEnrolment) => ({
  type: ADD_ENROLMENT,
  enrolment,
  scope: currentScope(),
})

export const removeEnrolment = (enrolment: PendingEnrolmentKey) => ({
  type: REMOVE_ENROLMENT,
  enrolment,
})

export const clearDraft = () => ({
  type: CLEAR_DRAFT,
})

export const dismissConfirmation = () => ({
  type: DISMISS_CONFIRMATION,
})

export const dismissSubmitFailure = () => ({
  type: DISMISS_SUBMIT_FAILURE,
})

export const confirmDraft = () => ({
  type: API_ENROLMENT_ENTITLEMENTS_ENROLMENTS_CREATE,
})

export type ConfirmationContext = {
  request: ConfirmationRequest;
}

type ConfirmDraftStartedAction = {
  type: typeof CONFIRM_DRAFT_STARTED;
}

type ConfirmDraftSucceededAction = {
  type: typeof CONFIRM_DRAFT_SUCCEEDED;
  context: ConfirmationContext;
}

type ConfirmDraftFailedAction = {
  type: typeof CONFIRM_DRAFT_FAILED;
  status?: string;
  errors?: ConfirmationError[];
  context: ConfirmationContext;
}

export type EnrolmentDraftAction =
  | ReturnType<typeof toggleUnenrolment>
  | ReturnType<typeof addEnrolment>
  | ReturnType<typeof removeEnrolment>
  | ReturnType<typeof clearDraft>
  | ReturnType<typeof dismissConfirmation>
  | ReturnType<typeof dismissSubmitFailure>
  | ReturnType<typeof confirmDraft>
  | ConfirmDraftStartedAction
  | ConfirmDraftSucceededAction
  | ConfirmDraftFailedAction
